<script setup lang="ts">
import type { Menu } from '~/types'

interface Props {
  menu: Menu.Model
}

defineProps<Props>()

const menuItemOpened = useState<MenuIdState>('menu-item', () => ({ menuId: null }))
const topMenuOpened = useState<MenuIdState>('top-menu-item', () => ({ menuId: null }))
const isMainMenuOpened = useState<boolean>('is-main-menu-opened', () => false)

const target = useTemplateRef<HTMLDivElement>('target')
onClickOutside(target, (event) => {
  topMenuOpened.value.menuId = null
  if (event.target?.closest('.hamb')) {
    return
  }
  isMainMenuOpened.value = false
})
</script>

<template>
  <div
    ref="target"
    class="header-menu"
    :class="{ 'header-menu--submenu-open': menuItemOpened.menuId || topMenuOpened.menuId }"
  >
    <Menu
      :menu="menu"
      class="header-menu__wrapper"
    />
  </div>
</template>

<style lang="scss">
.header-menu {
  @apply h-full;

  &__wrapper {
    @apply h-full transition-transform;
  }

  &--submenu-open &__wrapper {
    @apply max-xl:-translate-x-full;
  }
}
</style>
